// extracted by mini-css-extract-plugin
export var active = "new-sidebar-module--active--e7893";
export var bump = "new-sidebar-module--bump--b8ec4";
export var burger = "new-sidebar-module--burger--5969c";
export var burger__button = "new-sidebar-module--burger__button--82ecb";
export var cartButton = "new-sidebar-module--cartButton--eb732";
export var cartButtonDesktop = "new-sidebar-module--cartButtonDesktop--5e75c";
export var cartButtonMobile = "new-sidebar-module--cartButtonMobile--31923";
export var cartButtonWrapp = "new-sidebar-module--cartButtonWrapp--8ac62";
export var cartButtonWrappContainer = "new-sidebar-module--cartButtonWrappContainer--8a1dc";
export var cartCount = "new-sidebar-module--cartCount--3cff9";
export var closeBtn = "new-sidebar-module--closeBtn--0d1f0";
export var closeIcon = "new-sidebar-module--closeIcon--6d8cd";
export var logo = "new-sidebar-module--logo--49083";
export var mobileNavbar = "new-sidebar-module--mobileNavbar--f8529";
export var mobileNavbar__logo = "new-sidebar-module--mobileNavbar__logo--953a2";
export var mobileNavbar__toggle = "new-sidebar-module--mobileNavbar__toggle--f49d3";
export var mobileRightSection = "new-sidebar-module--mobileRightSection--5a1b0";
export var nav = "new-sidebar-module--nav--1dcf4";
export var navAbsolute = "new-sidebar-module--nav--absolute--3e8f7";
export var navDarkTheme = "new-sidebar-module--navDarkTheme--65e02";
export var nav__border = "new-sidebar-module--nav__border--74053";
export var nav__close = "new-sidebar-module--nav__close--e2504";
export var nav__content = "new-sidebar-module--nav__content--d5e92";
export var nav__hidden = "new-sidebar-module--nav__hidden--631ba";
export var nav__img = "new-sidebar-module--nav__img--9a85e";
export var nav__item = "new-sidebar-module--nav__item--47875";
export var nav__lang = "new-sidebar-module--nav__lang--058c3";
export var nav__langBtn = "new-sidebar-module--nav__langBtn--33588";
export var nav__langLi = "new-sidebar-module--nav__langLi--f927c";
export var nav__langTxt = "new-sidebar-module--nav__langTxt--eab8a";
export var nav__langUl = "new-sidebar-module--nav__langUl--dd8fc";
export var nav__langWrapp = "new-sidebar-module--nav__langWrapp--4b4e8";
export var nav__link = "new-sidebar-module--nav__link--1cce6";
export var nav__list = "new-sidebar-module--nav__list--a3ffd";
export var nav__menu = "new-sidebar-module--nav__menu--c7daa";
export var nav__ul = "new-sidebar-module--nav__ul--33a24";
export var social = "new-sidebar-module--social--21421";
export var social__link = "new-sidebar-module--social__link--e0324";
export var social__list = "new-sidebar-module--social__list--2f00c";
export var toggleButton = "new-sidebar-module--toggleButton--eaabf";